import { render, staticRenderFns } from "./ModifyDeliver.vue?vue&type=template&id=152ca11c&scoped=true&"
import script from "./ModifyDeliver.vue?vue&type=script&lang=js&"
export * from "./ModifyDeliver.vue?vue&type=script&lang=js&"
import style0 from "./ModifyDeliver.vue?vue&type=style&index=0&id=152ca11c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "152ca11c",
  null
  
)

export default component.exports